export default {
  name: 'informations_sepa_mandate_terms',
  component_path: 'modules/procedures/blocks/informations/BlockTermsOfUse',
  static_mandatory: ['sameAs:true']
}